import { Dispatch, SetStateAction } from 'react';

import { IMissingInformation } from '../../../pages/PersonalInformation/PersonalInformation.types';
import { IUser } from '../../../shared/ts/user';

export const userLegalInfoFieldsNames = [
  'company_name',
  'vat_number',
  'company_city',
  'company_country',
  'company_province',
  'company_address',
  'company_postcode',
] as const;

export type IUserLegalInfoFieldsNames = typeof userLegalInfoFieldsNames[number];

export type IUserLegalInfoFormFields = {
  [K in IUserLegalInfoFieldsNames]?: string | null;
};

export interface IUserLegalInfoFieldsState {
  errorLabel: string;
  hasErrors: boolean;
  initValue: string | null | undefined;
  isEditing: boolean;
  label: string;
  name: IUserLegalInfoFieldsNames;
  type: 'text' | 'date';
  value: string | null | undefined;
}

export interface UserLegalInfoFieldsProps {
  user: IUser | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (updatedUser: any) => void;
  fields: IUserLegalInfoFieldsState[];
  setFields: React.Dispatch<React.SetStateAction<IUserLegalInfoFieldsState[]>>;
  setMissingUserLegalInformation: Dispatch<
    SetStateAction<IMissingInformation | null>
  >;
}
